import { createRouter, createWebHashHistory } from 'vue-router';
import TrizPage from '@/pages/TrizPage.vue';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/result',
        },
        {
            path: '/result',
            component: TrizPage,
        },
        {
            path: '/result/:triz_mind_id',
            component: TrizPage,
        }
    ],
});

export default router;
